import React, { useEffect, useState, useRef } from "react";
import { Select, Divider, Checkbox, Tag } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const CheckboxSelect = ({
    icon,
    placeholder,
    options = [],
    selectedValues = [],
    onChange = () => { },
    isClearable = false,
    onAnyChange = () => { },
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const clearedRef = useRef(false);
    const hasMountedRef = useRef(false);
    const prevSelectedValues = useRef([]);

    const isAllSelected =
        selectedValues?.length === options?.length && options?.length > 0;

    useEffect(() => {
        // Mark mounted without auto-selecting all options
        if (!hasMountedRef.current && options.length > 0) {
            hasMountedRef.current = true;
        }
    }, [options]);

    useEffect(() => {
        if (hasMountedRef.current && JSON.stringify(prevSelectedValues.current) !== JSON.stringify(selectedValues)) {
            onAnyChange();
            prevSelectedValues.current = selectedValues;
        }
    }, [selectedValues]);

    const toggleItem = (value) => {
        if (selectedValues.includes(value)) {
            onChange(selectedValues.filter((v) => v !== value));
        } else {
            onChange([...selectedValues, value]);
        }
    };

    const handleSelectAll = (e) => {
        onChange(e.target.checked ? options.map((o) => o.value) : []);
    };

    const handleClear = (e) => {
        e.stopPropagation();
        clearedRef.current = true;
        onChange([]);
        setDropdownOpen(false);
    };

    const handleRemoveTag = (value) => {
        onChange(selectedValues.filter((v) => v !== value));
    };

    const dropdownRender = () => (
        <>
            <div style={{ padding: "8px 12px" }}>
                <Checkbox className="custom-checkbox-wrapper checkbox-hover-style" onChange={handleSelectAll} checked={isAllSelected}>
                    Select All
                </Checkbox>
            </div>
            <Divider style={{ margin: 0 }} />
            <div className="wlj-job-filter-dropdown-list" style={{ maxHeight: 240, overflowY: "auto", padding: "4px 12px" }}>
                {/* {options.map((option) => (
                    <div key={option.value} style={{ marginBottom: 8 }}>
                        <Checkbox
                            className="custom-checkbox-wrapper checkbox-hover-style"
                            checked={selectedValues.includes(option.value)}
                            onChange={() => toggleItem(option.value)}
                        >
                            {option.label?.split(" (")[0] || option.label}
                        </Checkbox>
                    </div>
                ))} */}
                {options.map((option) => {
                    const isChecked = selectedValues.includes(option.value);
                    return (
                        <div className="custom-checkbox-item" key={option.value}  style={{ marginBottom: 8 }}>
                            <Checkbox
                                className={`custom-checkbox ${isChecked ? "checked" : ""}`}
                                checked={isChecked}
                                onChange={() => toggleItem(option.value)}
                            >
                                {option.label?.split(" (")[0] || option.label}
                            </Checkbox>
                        </div>
                    );
                })}
            </div>
        </>
    );

    const selectedTags = options.filter((o) => selectedValues.includes(o.value));

    const truncateText = (text, length) => {
        return text.length > length ? text.slice(0, length) + "..." : text;
    };

    const getCustomLabel = () => {
        if (selectedTags.length === 0) {
            return undefined;
        }
        // One available option should show its name, not "All"
        if (isAllSelected && options.length > 1) {
            const keyword = placeholder?.split(" ")[1] || "All";
            return `${keyword} (All)`;
        }
        if (selectedTags.length === 1) {
            return truncateText(selectedTags[0].label?.split(" (")[0] || selectedTags[0].label, 18);
        }
        if (selectedTags.length > 1) {
            const name = truncateText(selectedTags[0].label?.split(" (")[0], 18);
            return `${name} +${selectedTags.length - 1}`;
        }
        return undefined;
    };

    return (
        <div className="searchInput wlj-ddl-input d-flex align-items-center position-relative">
            {icon}
            <div className="dropdown-checkbox wlj-ddl-select-wrap">
                <Select
                    open={dropdownOpen}
                    onDropdownVisibleChange={(visible) => setDropdownOpen(visible)}
                    placeholder={placeholder}
                    value={getCustomLabel()}
                    dropdownRender={dropdownRender}
                    getPopupContainer={() => document.body}
                    popupClassName="wlj-job-filter-dropdown"
                    dropdownClassName="wlj-job-filter-dropdown"
                    dropdownStyle={{ maxHeight: 280, overflow: "auto" }}
                    listHeight={256}
                    virtual={false}
                    placement="bottomLeft"
                    popupMatchSelectWidth
                    style={{ width: "100%", borderRadius: 0 }}
                    showSearch={false}
                />
                {selectedValues.length > 0 && (
                    <CloseCircleOutlined
                        style={{
                            position: "absolute",
                            right: 30,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#999",
                            fontSize: 16,
                            cursor: "pointer",
                            zIndex: 2,
                        }}
                        onClick={handleClear}
                    />
                )}
            </div>
        </div>
    );
};

export default CheckboxSelect;



